export { default } from './AppIcon.vue';
